import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import dayjs from 'dayjs';
function getDays(date) {
  if (!date) return [];
  var unit = 'day';
  var template = 'YYYY-MM-DD';
  // 时间戳
  var time = new Date(date).getTime();
  // 前一天
  var prev = dayjs(time).subtract(1, unit).format(template);
  // 当前
  var current = dayjs(time).format(template);
  // 后一天
  var next = dayjs(time).add(1, unit).format(template);
  // 天数集合
  return [prev, current, next];
}
export function createRange(d) {
  var days = getDays(d);
  return {
    disabledDate: function disabledDate(t) {
      if (!d) return false;
      var v = dayjs(t).format('YYYY-MM-DD');
      if (days.includes(v)) {
        return false;
      }
      return true;
    }
  };
}